const numberToLocalString = (num: number) => {
  return num.toLocaleString("ko-KR");
};

export default numberToLocalString;
